import { cn } from "../../lib/utils";

const Chip = ({ label, icon, innerChip, rightContent, textProps, ...props }) => {
	return (
		<div
			{...props}
			className={cn(
				"flex rounded-full p-[4px_8px] gap-[4px] ring-1 ring-dark-10 w-fit items-center text-center",
				props?.className
			)}
			style={props?.style}
		>
			{icon && <span className={icon} />}
			<span className={cn("leading-[16px] text-12", textProps?.className)}>{label}</span>
			{rightContent && rightContent}
			{innerChip && (
				<div className="p-[0_6px] text-10 text-primary-70 font-bold bg-primary-10 rounded-full uppercase -mr-[2px] ml-[4px]">
					{innerChip}
				</div>
			)}
		</div>
	);
};

export default Chip;
